import React, {useContext, useEffect, useState} from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { NonaGrayImg } from '../../assets/images/images'
import mainContext from '../../contexts/mainContext'
import { checkOnBoardStatus, getStripeRefreshLink } from '../../Controllers/stripe'
import Loader from '../Loader/Loader'
import './stripe.css'

export default function ReturnUrl() {
    const { setPageload, pageload } = useContext(mainContext);
    const navigate = useNavigate()
    const [state, setState] = useState({
        msg: "",
        error: "",
        textClass: "error-text"
    })

    useEffect(() => {
        async function fetchRefreshLink() {
            let query = new URLSearchParams(window.location.search)
            let accountId = query.get("acc")
            let token = query.get("auth")
            const res = await getStripeRefreshLink(accountId, token)
            if (res.data.status === 200) {
                setState({ msg: "Please continue to onBoarding process.", textClass: "success-text" })
            } else {
                setState({ msg: res.data.errors[0].message, textClass: "error-text" })
            }
            setPageload(false)
        }
        setPageload(true)
        fetchRefreshLink()
        return () => { }
    }, [])



    return (
        <React.Fragment>
            <div className="stripe">
                <div className="container">
                    <section className='logo'>
                        <img src={NonaGrayImg} alt="" />
                    </section>
                    <section>
                        <h3 className={state.textClass}>{state.msg}</h3>

                    </section>
                    <section className='btn-sec'>
                        <button className='return-app' onClick={() => navigate(-1)}>Return to Nona</button>
                    </section>
                </div>
            </div>
            <Loader type='fullpage' open={pageload} />
        </React.Fragment>
    )
}


